import React, { useRef, useEffect, useCallback } from "react";
import { Input } from "antd";
import Icon, { Icons } from "../../../Icon";

function AutoCloseInput(props: any) {
  const { name, onCreateTag, setName, ownItem, setIsShowEdit, outSideClick } = props;
  const inputRef = useRef<any>();
  const iconRef = useRef<any>();

  const outClick = useCallback((e: any) => {
    if (!inputRef.current) return;
    if (e.target !== inputRef.current.input && e.target !== iconRef.current.querySelector("svg")) {
      outSideClick();
    }
    // console.log("this is document click", e.target === inputRef.current.input);
  }, []);

  useEffect(() => {
    document.removeEventListener("click", outClick);
    document.addEventListener("click", outClick);
    return () => {
      document.removeEventListener("click", outClick);
    };
  }, []);
  return (
    <Input
      value={name}
      ref={inputRef}
      autoFocus={true}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onPressEnter={(e) => {
        onCreateTag(e);
      }}
      onChange={(e) => {
        setName(e.target.value);
      }}
      maxLength={20}
      suffix={
        <Icon
          ref={iconRef}
          onClick={(e) => {
            inputRef.current?.focus();
            onCreateTag(e);
          }}
          style={{ color: "green" }}
          type="iconic_pc_im_Finish"
        />
      }
    />
  );
}

export default AutoCloseInput;
